__turbopack_context__.v({
  "card": "Accreditation-module-scss-module__lajX5G__card",
  "cardDescription": "Accreditation-module-scss-module__lajX5G__cardDescription",
  "cardTitle": "Accreditation-module-scss-module__lajX5G__cardTitle",
  "carousel": "Accreditation-module-scss-module__lajX5G__carousel",
  "container": "Accreditation-module-scss-module__lajX5G__container",
  "divider": "Accreditation-module-scss-module__lajX5G__divider",
  "embla": "Accreditation-module-scss-module__lajX5G__embla",
  "emblaContainer": "Accreditation-module-scss-module__lajX5G__emblaContainer",
  "emblaSlide": "Accreditation-module-scss-module__lajX5G__emblaSlide",
  "imageBox": "Accreditation-module-scss-module__lajX5G__imageBox",
  "mainTitle": "Accreditation-module-scss-module__lajX5G__mainTitle",
});
